import React, { useState, useEffect } from "react";
import Select, { SelectOption } from "@amzn/meridian/select";
import ParseService from "src/components/shared/utils/parseService";
import useProcessPathPairsContext from "src/components/shared/context/useProcessPathPairsContext";
import useBusinessUnitContext from "src/components/shared/context/useBusinessUnitContext";
import useCountryCodeContext from "src/components/shared/context/useCountryCodeContext";
import useLocaleContext from "src/components/shared/context/useLocaleContext";
import useEligibilityContext from "src/components/shared/context/useEligibilityContext";
import { ELIGIBILITY_STATUS } from "src/components/shared/constants/constants";
import { LOCALE_VALUES } from "src/constants";

const BusinessUnitSelect = () => {
  const DEFAULT_USER_INFO = "JFK27,CORP,USA";
  const SEPERATOR = ",";
  const TESTING_USER_INFOS = [
    "JFK27,CORP,USA",
    "DFH3,AMZL,USA",
    "SAT2,ARS,USA",
    "CHA1,RELO,USA",
    "ABE2,TSSL-Trad,USA",
    "ABE5,TSSL-Merch,USA",
    "BDL7,TSSL-MOD,USA",
    "MDW2,IXD,USA",
    "SWA1,SSD,USA",
    "OWD9,NASC,USA",
    "YXX2,ARS,CAN", // Canada site
    "DXT4,AMZL,CAN,Quebec", // Canada Quebec site
    "N/A,N/A,N/A", // site not eligible
  ];

  const [userInfo, setUserInfo] = useState(DEFAULT_USER_INFO);
  const { setProcessPathPairs } = useProcessPathPairsContext();
  const { setBusinessUnitValue } = useBusinessUnitContext();
  const { setCountryCodeValue } = useCountryCodeContext();
  const { setLanguage } = useLocaleContext();
  const { setHasConfirmedEligibility } = useEligibilityContext();

  useEffect(() => {
    const [siteCode, businessUnitValue, countryCodeValue] =
      userInfo.split(SEPERATOR);
    ParseService.parseCSVFiles(siteCode)
      .then((res) => {
        setProcessPathPairs(res);
        setBusinessUnitValue(businessUnitValue);
        setCountryCodeValue(countryCodeValue);
        siteCode === "DXT4"
          ? setLanguage(LOCALE_VALUES.FR_CA)
          : setLanguage(LOCALE_VALUES.EN_US);
        siteCode === "N/A"
          ? setHasConfirmedEligibility(ELIGIBILITY_STATUS.NO)
          : setHasConfirmedEligibility(ELIGIBILITY_STATUS.YES);
      })
      .catch((e) => {
        console.error(e.message);
      });
  }, [userInfo]);

  return (
    <Select
      value={userInfo}
      onChange={(userInfo) => setUserInfo(userInfo)}
      placeholder="Choose site"
      width={160}
      size={"small"}
    >
      {TESTING_USER_INFOS.map((userInfo, index) => (
        <SelectOption value={userInfo} label={userInfo} key={index} />
      ))}
    </Select>
  );
};

export default BusinessUnitSelect;
